import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import classNames from 'classnames';
import PDPNameSectionPlaceholder from './PDPNameSection/PDPNameSectionPlaceholder';
import PDPShopTabsBarPlaceholder from './PDPShopTabsBar/PDPShopTabsBarPlaceholder';
import PDPChooseYourOptionsPlaceholder from './PDPChooseYourOptions/PDPChooseYourOptionsPlaceholder';
import PDPProtectionPlanSelectorPlaceholder from './PDPProtectionPlanSelector/PDPProtectionPlanSelectorPlaceholder';
import PDPAddToBagSectionPlaceholder from './PDPAddToBagSection/PDPAddToBagSectionPlaceholder';
import useIsLayoutRevampVariant from './useIsLayoutRevampVariant';

/**
 * Hero-promise Suspense fallback: large image rect + minimal chrome.
 * Intentionally lighter than full-page PDPPlaceholder.
 */
const PDPHeroShellPlaceholder = t0 => {
  const $ = _c(33);
  const {
    className: parentClassName,
    isEditOrder: t1,
    pdpIsModularBYOProduct: t2
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const isLayoutRevamp = useIsLayoutRevampVariant(!pdpIsModularBYOProduct && !isEditOrder);
  let t3;
  if ($[0] !== parentClassName) {
    t3 = classNames("hidden lg:flex mx-auto my-0 py-0 flex-row-reverse !pt-2 !pb-8 px-5 md:px-[3.333vw] min-[1500px]:px-[50px] max-w-[1800px]", parentClassName);
    $[0] = parentClassName;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PDPNameSectionPlaceholder />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== isLayoutRevamp) {
    t5 = <PDPShopTabsBarPlaceholder isLayoutRevamp={isLayoutRevamp} />;
    $[3] = isLayoutRevamp;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <PDPChooseYourOptionsPlaceholder />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isLayoutRevamp) {
    t7 = <PDPProtectionPlanSelectorPlaceholder isLayoutRevamp={isLayoutRevamp} />;
    $[6] = isLayoutRevamp;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <PDPAddToBagSectionPlaceholder />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t5 || $[10] !== t7) {
    t9 = <div className="flex-none min-w-[460px] w-[460px] [@media(width:1024px)]:min-w-[400px] [@media(width:1024px)]:w-[400px]">{t4}{t5}{t6}{t7}{t8}</div>;
    $[9] = t5;
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      maxWidth: "calc((100vh - 194px) / 0.6666666666666666)"
    };
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex-1 mr-12"><div className="sticky top-8"><div className="mb-8 flex flex-col items-center relative" style={t10}><Placeholder loading={true} type="rect" style={{
            width: "50vw",
            height: "70vh",
            margin: "none"
          }} /></div></div></div>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t3 || $[15] !== t9) {
    t12 = <div className={t3} data-xc="PDPHeroShellPlaceholder-desktop">{t9}{t11}</div>;
    $[14] = t3;
    $[15] = t9;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== parentClassName) {
    t13 = classNames("flex flex-col lg:hidden", parentClassName);
    $[17] = parentClassName;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]"><PDPNameSectionPlaceholder /></div>;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Placeholder className="mb-1.5" loading={true} type="rect" style={{
      width: "100vw",
      aspectRatio: "1/1"
    }} />;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <PDPChooseYourOptionsPlaceholder />;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== isLayoutRevamp) {
    t17 = <PDPProtectionPlanSelectorPlaceholder isLayoutRevamp={isLayoutRevamp} />;
    $[22] = isLayoutRevamp;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <PDPAddToBagSectionPlaceholder />;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== t17) {
    t19 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]">{t16}{t17}{t18}</div>;
    $[25] = t17;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t13 || $[28] !== t19) {
    t20 = <div className={t13} data-xc="PDPHeroShellPlaceholder-mobile">{t14}{t15}{t19}</div>;
    $[27] = t13;
    $[28] = t19;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t12 || $[31] !== t20) {
    t21 = <>{t12}{t20}</>;
    $[30] = t12;
    $[31] = t20;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  return t21;
};
PDPHeroShellPlaceholder.propTypes = {
  className: PropTypes.string,
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool
};
export default PDPHeroShellPlaceholder;